module.exports = __webpack_public_path__ + "img/geolocation.27517fe3.svg";